<style>
    .label {
        font-weight: 600;
    }

    .label-custom{
        font-weight: 600;
        font-style: italic;
    }
</style>

<template>
    <div class="h-100">
        <app-overlay-loader v-if="preloader" />
        <div class="card-body">
            <form ref="form" data-url="/crud" class="mb-0" :class="{ 'loading-opacity': preloader }">
                <div class="col-md-12 p-3">
                    <div class="col-sm-12 col-md-6">
                        <app-breadcrumb
                            :page-title="$t('Review information')"
                            :directory="$t('list')"
                            :icon="'grid'" />
                    </div>
                    <div class="form-group row align-items-center">
                        <label for="textarea_field" class="col-sm-3 col-md-3 mb-md-0 label">
                            {{ $t('description') }}
                        </label>
                        <app-input
                            id="textarea_field"
                            class="col-sm-9"
                            type="textarea"
                            :placeholder="$t('Enter description')"
                            v-model="inputs.description" />
                    </div>
                    <div>
                        <div class="row">
                            <div class="col-md-3"></div>
                            <div class="col-md-3"></div>
                            <div class="col-md-3">
                                <button type="button" class="btn btn-danger w-100"
                                    @click="removeReview">
                                    {{ $t('cancel') }}
                                </button>
                            </div>
                            <div class="col-6 col-md-3 mb-2">
                                <button type="button" class="btn btn-success w-100"
                                    @click="submitForm">
                                    {{ $t('Save Permanently') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
					v-if="showModal"
					@close="showModal = false"
					@downloadPO="downloadPO"
					@downloadSO="downloadSO"
					@goToContracts="goToContracts"
				/>
            </form>
        </div>
    </div>
</template>

<script>
import { FormMixin } from '../../../../../core/mixins/form/FormMixin.js';
import Modal from "./Modal.vue";

export default {
    mixins: [FormMixin],
    components: {
    	Modal
  	},
    data() {
        return {
            contract_id : null,
            version_no : null,
            showModal: false,
            preloader: false,
            inputs: {
                description:            null,
            },
        }
    },
    methods: {
        async loadData(){
            const savedInputs = localStorage.getItem('DataRevision');
            if (savedInputs) {
                this.inputs = JSON.parse(savedInputs);
            }
        },
        async submitForm(){
            const validations = {
                description: 'Description required',
            }

            if (!this.validateForm(this.inputs, validations)) {
                return;
            }

            this.preloader = true;
            try {
                const formData = new FormData();
                const contractMaster = localStorage.getItem("DataContractMaster");
				const contractDetails = localStorage.getItem("DataContractDetail");
				const contractProducts = localStorage.getItem("selectedProducts");
				const contractSupplierDetail = localStorage.getItem("DataSupplierDetail");
				const contractCustomerDetail = localStorage.getItem("DataCustomerDetail");
				const contractRevision = localStorage.getItem("DataRevision");

				formData.append("contractMaster", contractMaster);
				formData.append("contractDetails", contractDetails);
				formData.append("contractProducts", contractProducts);
				formData.append("contractSupplierDetail", contractSupplierDetail);
				formData.append("contractCustomerDetail", contractCustomerDetail);
                formData.append("contractRevision", contractRevision)

                const response = await axios.post('/api/contracts/upd_contract', formData);

                this.contract_id = response.data.version.contract_id;
                this.version_no = response.data.version.revision_no;
                this.$toastr.s(response.data.message);
                setTimeout(() => {
                    localStorage.removeItem('DataContractDetail');
                    localStorage.removeItem('DataContractMaster');
                    localStorage.removeItem('DataProductDetail');
                    localStorage.removeItem('DataRevision');
                    localStorage.removeItem('DataSupplierDetail');
                    localStorage.removeItem('DataCustomerDetail');
                    localStorage.removeItem('selectedProducts');
                    localStorage.removeItem('process_edit_contract');
                    this.showModal = true;
                }, 2000);
            } catch (error) {
                const message = error?.response?.data?.error ?? 'Error' ;
                console.warn(error);
                this.$toastr.e(message);
            }
            this.preloader = false;
        },

        validateForm(inputs, validations) {
            for (const [field, message] of Object.entries(validations)) {
                const value = field.split('.').reduce((o ,i) => o[i], inputs);
                if (!value) {
                    this.$toastr.e(this.$t(message));
                    return false;
                }
            }
            return true;
        },

        downloadPO() {
      		const base_url = localStorage.getItem("base_url");
            let url = `${base_url}/contracts/downloadPo/${this.contract_id}`;
            if (this.version_no) {
                url += `/${this.version_no}`;
            }
      		window.open(url, "_blank");
    	},

		downloadSO() {
			const base_url = localStorage.getItem("base_url");
            let url = `${base_url}/contracts/downloadSo/${this.contract_id}`;
            if (this.version_no) {
                url += `/${this.version_no}`;
            }
			window.open(url, "_blank");
		},

		goToContracts() {
			const base_url = localStorage.getItem("base_url");
			window.location.href = `${base_url}/contracts/list`;
		},

        removeReview() {
            localStorage.removeItem('DataContractDetail_edit');
            localStorage.removeItem('DataContractMaster_edit');
            localStorage.removeItem('DataProductDetail_edit');
            localStorage.removeItem('DataRevision_edit');
            localStorage.removeItem('DataSupplierDetail_edit');
            localStorage.removeItem('DataCustomerDetail_edit');
            localStorage.removeItem('selectedProducts_edit');
            localStorage.removeItem('selectedRevisions_edit');
            const base_url = localStorage.getItem('base_url');
            window.location.href = `${base_url}/contracts/list`;
        },

        beforeSubmit() {
            this.preloader = true;
        },
        submit() {
            this.save(this.inputs);
        },

        afterSuccess(res) {
            this.$toastr.s(res.data.message);
        },
        afterFinalResponse() {
            this.preloader = false;
            this.inputs = {
                gender: 'male',
            };
        },
        afterError(res) {
            this.$toastr.e(res.data.message);
        },
        clear() {
            this.inputs = {
                gender: 'male',
            };
            this.fieldStatus = {
                isSubmit: false
            }
        },
    },
    watch : {
        inputs : {
            deep : true,
            handler(newVal){
                localStorage.setItem('DataRevision', JSON.stringify(newVal));
            }
        }
    },
    mounted() {
        this.loadData();
    },
}
</script>
